import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useState } from 'react';
import PageHeader from './molecules/PageHeader';
import BackToPreviousPage from './atoms/BackToPreviousPage';
import { useCreateNewEvent } from '../hooks/events.hook';

const CreateNewEvent = () => {
  const [errorMsg, setErrorMsg] = useState('');
  const { createNewEventMutation } = useCreateNewEvent();
  const saveEventName = () => {
    createNewEventMutation.mutate();
  };

  return (
    <div>
      <PageHeader
        RightSideComponent={BackToPreviousPage}
        previousPage='/manage/events'
        label='Back'
      >
        Create New Event
      </PageHeader>
      <div style={{ color: 'red' }}>{errorMsg}</div>
      <TextField
        margin='dense'
        fullWidth
        label='Event Name'
        name='newEventName'
        id='newEventName'
      />
      <div style={{ textAlign: 'right' }}>
        <Button variant='contained' onClick={saveEventName}>
          Save
        </Button>
      </div>
    </div>
  );
};

export default CreateNewEvent;
